
export default function Services() {
  const services = [
    {
      icon: 'ri-graduation-cap-line',
      title: 'ネイルレッスン・講習',
      description: '初心者から上級者まで、レベルに応じた丁寧な指導を行います。対面レッスンで確実にスキルアップできます。',
      features: ['基礎から応用まで', 'マンツーマン指導', '資格取得サポート', 'アフターフォロー'],
      color: 'from-pink-400 to-pink-600'
    },
    {
      icon: 'ri-computer-line',
      title: 'オンラインレッスン',
      description: '自宅にいながらプロの技術を学べるオンラインレッスン。全国どこからでも受講可能です。',
      features: ['全国対応', 'フレキシブルな時間', '録画復習可能', 'リアルタイム指導'],
      color: 'from-teal-400 to-teal-600'
    },
    {
      icon: 'ri-shopping-bag-line',
      title: 'ネイル商品販売',
      description: 'プロ仕様のネイルチップや関連商品を企画・製造・販売。高品質な商品をお届けします。',
      features: ['オリジナル商品', '高品質素材', '通信販売対応', 'カスタマイズ可能'],
      color: 'from-purple-400 to-purple-600'
    }
  ];

  return (
    <section id="services" className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h3 className="text-4xl md:text-5xl font-bold mb-6 text-gray-800">
            <strong>サービス内容</strong>
          </h3>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            ネイルに関するあらゆるニーズにお応えする、包括的なサービスをご提供しています
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div key={index} className="bg-white rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 overflow-hidden group">
              <div className={`h-2 bg-gradient-to-r ${service.color}`}></div>
              
              <div className="p-8">
                <div className={`w-16 h-16 bg-gradient-to-r ${service.color} rounded-full flex items-center justify-center mb-6 group-hover:scale-110 transition-transform`}>
                  <i className={`${service.icon} text-2xl text-white`}></i>
                </div>
                
                <h4 className="text-2xl font-bold mb-4 text-gray-800">
                  <a href="#services" className="hover:text-pink-500 transition-colors">
                    {service.title}
                  </a>
                </h4>
                
                <p className="text-gray-600 mb-6 leading-relaxed">
                  {service.description}
                </p>
                
                <ul className="space-y-3">
                  {service.features.map((feature, featureIndex) => (
                    <li key={featureIndex} className="flex items-center text-gray-700">
                      <i className="ri-check-line text-green-500 mr-3"></i>
                      <span>{feature}</span>
                    </li>
                  ))}
                </ul>
                
                
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
